import { render, staticRenderFns } from "./LinkToLogin.vue?vue&type=template&id=5725d16c&scoped=true&"
import script from "./LinkToLogin.vue?vue&type=script&lang=js&"
export * from "./LinkToLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5725d16c",
  null
  
)

export default component.exports